import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const estimateRevenue = (payload) => api.post("/estimate", payload).then((r) => r.data);
export const simulate = (payload) => api.post("/simulate", payload).then((r) => r.data);
